export const INFO_TYPE = 'info';
export const WARNING_TYPE = 'warning';
export const SUCCESS_TYPE = 'success';
export const ERROR_TYPE = 'error';

export const DEFAULT_NOTIFICATION_TIMEOUT = 3000;

export const notifications: {
  INFO_TYPE: typeof INFO_TYPE;
  WARNING_TYPE: typeof WARNING_TYPE;
  SUCCESS_TYPE: typeof SUCCESS_TYPE;
  ERROR_TYPE: typeof ERROR_TYPE;
} = { INFO_TYPE, WARNING_TYPE, SUCCESS_TYPE, ERROR_TYPE };

export type TNotificationType = (typeof notifications)[keyof typeof notifications];
